export const courses = [
  // Seymour Golf and Country Club
  {
    id: 'seymour',
    name: 'Seymour Golf and Country Club',
    location: { lat: 49.314825, lng: -122.967597 },
    municipality: 'North Vancouver'
  },
  // Burnaby courses
  {
    id: 'burnaby-mountain',
    name: 'Burnaby Mountain Golf Course',
    location: { lat: 49.264887, lng: -122.943087 },
    municipality: 'Burnaby'
  },
  {
    id: 'riverway',
    name: 'Riverway Golf Course',
    location: { lat: 49.201850, lng: -122.998459 },
    municipality: 'Burnaby'
  },
  // Vancouver courses
  {
    id: 'langara',
    name: 'Langara Golf Course',
    location: { lat: 49.220635, lng: -123.111269 },
    municipality: 'Vancouver'
  },
  {
    id: 'fraserview',
    name: 'Fraserview Golf Course',
    location: { lat: 49.213063, lng: -123.048389 },
    municipality: 'Vancouver'
  },
  {
    id: 'mccleery',
    name: 'McCleery Golf Course',
    location: { lat: 49.220763, lng: -123.167694 },
    municipality: 'Vancouver'
  },
 
  // Northlands Golf Course
  {
    id: 'northlands',
    name: 'Northlands Golf Course',
    location: { lat: 49.321613, lng: -122.980783 },
    municipality: 'North Vancouver'
  },
  // Gleneagles Golf Course
  {
    id: 'gleneagles',
    name: 'Gleneagles Golf Course',
    location: { lat: 49.363202, lng: -123.279163 },
    municipality: 'West Vancouver'
  },
  // University Golf Club
  {
    id: 'university',
    name: 'University Golf Club',
    location: { lat: 49.264310, lng: -123.229650 },
    municipality: 'Vancouver'
  },
  // Sky Course - GreenTee Country Club
  {
    id: 'skyCourse',
    name: 'Sky Course - GreenTee Country Club',
    location: { lat: 49.304800, lng: -122.791900 },
    municipality: 'Coquitlam (Westwood Plateau)'
  },
  // Fine Course - GreenTee Country Club
  {
    id: 'fineCourse',
    name: 'Fine Course - GreenTee Country Club',
    location: { lat: 49.304800, lng: -122.791900 },
    municipality: 'Coquitlam (Westwood Plateau)'
  },
  // Carnoustie Golf Club
  {
    id: 'carnoustie',
    name: 'Carnoustie Golf Club',
    location: { lat: 49.262800, lng: -122.770900 },
    municipality: 'Port Coquitlam'
  },
  // Golden Eagle Golf Club - North Course
  {
    id: 'genorthcourse',
    name: 'Golden Eagle Golf Club - North Course',
    location: { lat: 49.246800, lng: -122.690900 },
    municipality: 'Pitt Meadows'
  },
  // Golden Eagle Golf Club - South Course
  {
    id: 'gesouthcourse',
    name: 'Golden Eagle Golf Club - South Course',
    location: { lat: 49.246800, lng: -122.690900 },
    municipality: 'Pitt Meadows'
  },
  // Surrey Golf Club - Main Course
  {
    id: 'surreygolfclub',
    name: 'Surrey Golf Club - Main Course',
    location: { lat: 49.147800, lng: -122.803900 },
    municipality: 'Surrey'
  },
  // Surrey Golf Club - Willows 9
  {
    id: 'surreywillows',
    name: 'Surrey Golf Club - Willows 9',
    location: { lat: 49.147800, lng: -122.803900 },
    municipality: 'Surrey'
  },
  // Savage Creek
  {
    id: 'savagecreek',
    name: 'Savage Creek',
    location: { lat: 49.170800, lng: -123.090900 },
    municipality: 'Richmond'
  },
  // Mylora Golf Course
  {
    id: 'mylora18',
    name: 'Mylora Golf Course',
    location: { lat: 49.112800, lng: -123.120900 },
    municipality: 'Richmond'
  },
  // Country Meadows
  {
    id: 'countrymeadows',
    name: 'Country Meadows',
    location: { lat: 49.145800, lng: -123.080900 },
    municipality: 'Richmond'
  },
  // Furry Creek Golf and Country Club
  {
    id: 'furrycreek',
    name: 'Furry Creek Golf and Country Club',
    location: { lat: 49.610800, lng: -123.222900 },
    municipality: 'Furry Creek'
  },
  // Meadow Gardens Golf Club
  {
    id: 'meadowgardens',
    name: 'Meadow Gardens Golf Club',
    location: { lat: 49.2214, lng: -122.6897 },
    municipality: 'Pitt Meadows'
  },
  // Musqueam Golf & Learning Academy
  {
    id: 'musqueam',
    name: 'Musqueam Golf & Learning Academy',
    location: { lat: 49.22522093649613, lng: -123.19207729880631 },
    municipality: 'Vancouver'
  },
  {
    id: 'hillsatportal',
    name: 'The Hills at Portal Golf Club',
    location: { lat: 49.009115336939374, lng: -122.75299559145994 },
    municipality: 'White Rock'
  },
  {
    id: 'meridianhills',
    name: 'Meridian Hills Golf Par 3',
    location: { lat: 49.02165638187732, lng: -122.75642716116866 },
    municipality: 'White Rock'
  },
  {
    id: 'harrisonresort',
    name: 'Harrison Resort Golf Course',
    location: { lat: 49.27907769131372, lng: -121.7760964653841 },
    municipality: 'Agassiz'
  },
  {
    id: 'thefalls',
    name: 'The Falls Golf Club',
    location: { lat: 49.15294, lng: -121.8093 },
    municipality: 'Chilliwack'
  },
  {
    id: 'tsawwassensprings',
    name: 'Tsawwassen Springs Golf',
    location: { lat: 49.031763, lng: -123.083439 },
    municipality: 'Delta'
  },
  {
    id: 'sandpiperresort',
    name: 'Sandpiper Resort Golf Course',
    location: { lat: 49.2551139169746, lng: -121.9456905816905 },
    municipality: 'Harrison Mills'
  },
  {
    id: 'hopegolf',
    name: 'Hope Golf & Country Club',
    location: { lat: 49.3883969824488, lng: -121.431391615469 },
    municipality: 'Hope'
  },
  {
    id: 'greenteelangley',
    name: 'GreenTee Country Club Langley',
    location: { lat: 49.145950112063, lng: -122.493144579232 },
    municipality: 'Langley'
  },
  {
    id: 'mountbrenton',
    name: 'Mount Brenton Golf Club',
    location: { lat: 48.91443, lng: -123.71477 },
    municipality: 'Chemainus'
  },
  {
    id: 'arbutusridge',
    name: 'Arbutus Ridge Golf Club',
    location: { lat: 48.68817713673944, lng: -123.5526314425321 },
    municipality: 'Cobble Hill'
  },
  {
    id: 'crownislepark',
    name: 'The Park at Crown Isle',
    location: { lat: 49.712474, lng: -124.957739 },
    municipality: 'Comox'
  },
  {
    id: 'crownisleresort',
    name: 'Crown Isle Resort and Golf Community',
    location: { lat: 49.7124781, lng: -124.9581757 },
    municipality: 'Courtenay'
  },
  {
    id: 'mulligans',
    name: 'Mulligans Golf Course',
    location: { lat: 49.718367, lng: -124.9974237 },
    municipality: 'Courtenay'
  },
  {
    id: 'sunnydale',
    name: 'Sunnydale Golf and Country Club',
    location: { lat: 49.73464715782828, lng: -125.0030825890233 },
    municipality: 'Courtenay'
  },
  {
    id: 'cowichan',
    name: 'Cowichan Golf & Country Club',
    location: { lat: 48.750912, lng: -123.669298 },
    municipality: 'Duncan'
  },
  {
    id: 'duncanmeadows',
    name: 'Duncan Meadows Golf Course',
    location: { lat: 48.8077293, lng: -123.7539486 },
    municipality: 'Duncan'
  },
  {
    id: 'marchmeadows',
    name: 'March Meadows Golf Club',
    location: { lat: 48.826475, lng: -124.192114 },
    municipality: 'Honeymoon Bay'
  },
  {
    id: 'morningstar',
    name: 'Morningstar Golf Club',
    location: { lat: 49.327541, lng: -124.34912 },
    municipality: 'Parksville'
  },
  {
    id: 'saltspring',
    name: 'Salt Spring Island Golf Club',
    location: { lat: 48.86845, lng: -123.52627 },
    municipality: 'Salt Spring Island'
  },
  {
    id: 'bearmountainmountain',
    name: 'Bear Mountain Golf Resort - Mountain Course',
    location: { lat: 48.476822, lng: -123.531502 },
    municipality: 'Victoria'
  },
  {
    id: 'bearmountainvalley',
    name: 'Bear Mountain Golf Resort - Valley Course',
    location: { lat: 48.476822, lng: -123.531502 },
    municipality: 'Victoria'
  },
  {
    id: 'metchosin',
    name: 'Metchosin Golf Course',
    location: { lat: 48.389986, lng: -123.525392 },
    municipality: 'Victoria'
  },
  {
    id: 'bigsky',
    name: 'Big Sky Golf Club',
    location: { lat: 50.3037870020501, lng: -122.7675407999999 },
    municipality: 'Pemberton'
  },
  {
    id: 'chateauwhistler',
    name: 'Fairmont Chateau Whistler Golf Club',
    location: { lat: 50.12166550002307, lng: -122.9435303426279 },
    municipality: 'Whistler'
  },
  {
    id: 'bighorn',
    name: 'Bighorn Golf & Country Club',
    location: { lat: 50.68837, lng: -120.29801 },
    municipality: 'Kamloops'
  },
  {
    id: 'eaglepoint',
    name: 'Eaglepoint Golf Resort',
    location: { lat: 50.639827, lng: -120.085244 },
    municipality: 'Kamloops'
  },
  {
    id: 'kamloopsgolf',
    name: 'Kamloops Golf & Country Club',
    location: { lat: 50.712588, lng: -120.446978 },
    municipality: 'Kamloops'
  },
  {
    id: 'mountpaul',
    name: 'Mount Paul Golf Course',
    location: { lat: 50.6925442, lng: -120.3241404 },
    municipality: 'Kamloops'
  },
  {
    id: 'michaelbrook',
    name: 'Michaelbrook Golf',
    location: { lat: 49.83951, lng: -119.47376 },
    municipality: 'Kelowna'
  },
  {
    id: 'missioncreek',
    name: 'Mission Creek Golf Club',
    location: { lat: 49.8590606609053, lng: -119.453114815343 },
    municipality: 'Kelowna'
  },
  {
    id: 'sunsetranch',
    name: 'Sunset Ranch Golf and Country Club',
    location: { lat: 49.9411533, lng: -119.3514825 },
    municipality: 'Kelowna'
  },
  {
    id: 'towerranch',
    name: 'Tower Ranch Golf Club',
    location: { lat: 49.9135, lng: -119.3367 },
    municipality: 'Kelowna'
  },
  {
    id: 'merrittgolf',
    name: 'Merritt Golf & Country Club',
    location: { lat: 50.119516, lng: -120.7948836 },
    municipality: 'Merritt'
  },
  {
    id: 'predatorridge',
    name: 'Predator Ridge Resort',
    location: { lat: 50.189086, lng: -119.387606 },
    municipality: 'Vernon'
  },
  {
    id: 'spallumcheen',
    name: 'Spallumcheen Golf & Country Club',
    location: { lat: 50.35949454588695, lng: -119.2848712421737 },
    municipality: 'Vernon'
  },
  {
    id: 'theriseresort',
    name: 'The Rise Resort',
    location: { lat: 50.265413, lng: -119.342982 },
    municipality: 'Vernon'
  },
  {
    id: 'tobiano',
    name: "Tobiano Golf Course",
    location: { lat: 50.73477, lng: -120.68885 },
    municipality: 'Kamloops'
  },
  {
    id: 'talkingrock',
    name: "Talking Rock Golf Course",
    location: { lat: 50.875889, lng: -119.615968 },
    municipality: 'Chase'
  },
  {
    id: 'sunpeaks',
    name: "Sun Peaks Golf Course",
    location: { lat: 50.880145, lng: -119.895751 },
    municipality: 'Sun Peaks'
  },
  {
    id: 'shuswapnational',
    name: "Shuswap National Golf Course",
    location: { lat: 50.657441, lng: -119.214054 },
    municipality: 'Salmon Arm'
  },
  {
    id: 'summerland',
    name: "Summerland Golf & Country Club",
    location: { lat: 49.5571, lng: -119.69549 },
    municipality: 'Summerland'
  },
  {
    id: 'fairviewmountain',
    name: "Fairview Mountain Golf Club",
    location: { lat: 49.165066, lng: -119.592555 },
    municipality: 'Oliver'
  },
  {
    id: 'nkmipcanyon',
    name: "NK'Mip Canyon Desert Golf Course",
    location: { lat: 49.195122, lng: -119.532249 },
    municipality: 'Oliver'
  },
  {
    id: 'osoyoosdesertgold',
    name: "Osoyoos Golf Club - Desert Gold",
    location: { lat: 49.016595, lng: -119.488688 },
    municipality: 'Osoyoos'
  },
  {
    id: 'osoyoosparkmeadows',
    name: "Osoyoos Golf Club - Park Meadows",
    location: { lat: 49.016595, lng: -119.488688 },
    municipality: 'Osoyoos'
  },
  {
    id: 'revelstoke',
    name: "Revelstoke Golf Club",
    location: { lat: 51.013974, lng: -118.226163 },
    municipality: 'Revelstoke'
  },
  {
    id: 'princeton',
    name: "Princeton Golf Club",
    location: { lat: 49.457086, lng: -120.469605 },
    municipality: 'Princeton'
  },
  {
    id: 'storeycreek',
    name: "Storey Creek Golf Club",
    location: { lat: 49.9291903, lng: -125.210295 },
    municipality: 'Campbell River'
  },
  {
    id: 'qualicumbeach',
    name: "Qualicum Beach Memorial Golf Club",
    location: { lat: 49.354521, lng: -124.44178 },
    municipality: 'Qualicum Beach'
  },
  {
    id: 'blueocean',
    name: "Blue Ocean Golf Club",
    location: { lat: 49.490136, lng: -123.785349 },
    municipality: 'Sechelt'
  },
  {
    id: 'covelinks',
    name: "Cove Links Golf Course",
    location: { lat: 49.110112, lng: -123.074345 },
    municipality: 'Delta'
  },
  {
    id: 'northviewridge',
    name: "Northview Golf & Country Club - Ridge Course",
    location: { lat: 49.1275192, lng: -122.767719 },
    municipality: 'Surrey'
  },
  {
    id: 'northviewcanal',
    name: "Northview Golf & Country Club - Canal Course",
    location: { lat: 49.1275192, lng: -122.767719 },
    municipality: 'Surrey'
  },
  {
    id: 'morgancreek',
    name: "Morgan Creek Golf Course",
    location: { lat: 49.0649475, lng: -122.7819573 },
    municipality: 'Surrey'
  },
  {
    id: 'deltagolf',
    name: "Delta Golf Club",
    location: { lat: 49.0978528, lng: -122.893996 },
    municipality: 'Delta'
  },
  {
    id: 'kingslinks',
    name: "Kings Links by the Sea",
    location: { lat: 49.0639604, lng: -123.0185491 },
    municipality: 'Delta'
  },
  {
    id: 'belmont',
    name: "Belmont Golf Course",
    location: { lat: 49.155629, lng: -122.5944041 },
    municipality: 'Langley'
  },
  {
    id: 'swanesetresort',
    name: "Swan-e-set Bay Resort - Resort Course",
    location: { lat: 49.3060072, lng: -122.6597133 },
    municipality: 'Pitt Meadows'
  },
  {
    id: 'swanesetlinks',
    name: "Swan-e-set Bay Resort - Links Course",
    location: { lat: 49.3060072, lng: -122.6597133 },
    municipality: 'Pitt Meadows'
  },
  {
    id: 'hazelmere',
    name: "Hazelmere Golf Course",
    location: { lat: 49.0121522, lng: -122.7188807 },
    municipality: 'Surrey'
  },
  {
    id: 'redwoods',
    name: "The Redwoods Golf Course",
    location: { lat: 49.1689656, lng: -122.6170816 },
    municipality: 'Langley'
  },
  {
    id: 'twoeagles',
    name: "Two Eagles Golf Course",
    location: { lat: 49.8383545, lng: -119.6067933 },
    municipality: 'West Kelowna'
  },
  {
    id: 'guildford',
    name: "Guildford Golf & Country Club",
    location: { lat: 49.1967446, lng: -122.8005956 },
    municipality: 'Surrey'
  },
];